import { render } from "./UserCategories.vue?vue&type=template&id=27a27307"
import script from "./UserCategories.vue?vue&type=script&lang=js"
export * from "./UserCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__